// footer acco js start
if (window.screen.width < 769) {
function setupAccordion() {
            // Get all the headings
            const headings = document.querySelectorAll('.acc_heading_1');

            headings.forEach(heading => {
             
                heading.addEventListener('click', function() {
                  headings.forEach(heading => {
                    heading.classList.remove('active');
                  });
                  
                    const uls = this.nextElementSibling;
                    document.querySelectorAll('.acoo_child').forEach(u => {
                      if(!(uls == u)){
                        
                        u.style.display = 'none';
                        
                      }
                    });

                    // Toggle the clicked heading's <ul> element

                    if (uls.style.display === 'block') {
                      heading.classList.remove('active');
                        uls.style.display = 'none';
                    } else {
                      heading.classList.add('active');
                        uls.style.display = 'block';
                    }

                });
            });
        }

        setupAccordion();
}
// footer acco js end


// document.addEventListener('DOMContentLoaded', function() {
//   const variantImages = document.querySelectorAll('.variant_img');
//   console.log(variantImages,"variantImages")
//   const featuredImg = document.querySelector('.featured_img');
//   let originalSrc = featuredImg.getAttribute('src');
//   let originalSrcset = featuredImg.getAttribute('srcset');

//   variantImages.forEach(img => {
//     img.addEventListener('mouseover', function() {
//       // alert('Mouse over event triggered'); 
//       const imageParent = img.closest('.grid__item');
//       console.log("imageParent>>>",imageParent);
//         const featuredImg = imageParent.querySelectorAll('.featured_img');
//       const newSrc = img.getAttribute('src');
//       // const newSrcset = img.getAttribute('data-srcset');
//       featuredImg.forEach((item)=>{
        
//       item.setAttribute('src', newSrc);
//       item.removeAttribute('srcset');
//       })
//     });

//     img.addEventListener('mouseout', function() {
//       featuredImg.setAttribute('src', originalSrc);
//       featuredImg.setAttribute('srcset', originalSrcset);
//     });

//     img.addEventListener('click', function(e) {
//       e.preventDefault();
//       // alert();
//       const imageParent = img.closest('.grid__item');
//       console.log("imageParent>>>",imageParent);
//         const featuredImg = imageParent.querySelectorAll('.featured_img');
//       const newSrc = img.getAttribute('src');
//       // const newSrcset = img.getAttribute('data-srcset');
//         featuredImg.forEach((item)=>{
        
//       item.setAttribute('src', newSrc);
//       item.removeAttribute('srcset');
//       })
//     });
//   });
// });





document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function()
             {
               const variantImages = document.querySelectorAll('.variant__img');
  console.log(variantImages, "variantImages");
  const featuredImg = document.querySelector('.featured_img');
  let originalSrc = featuredImg.getAttribute('src');
  let originalSrcset = featuredImg.getAttribute('srcset');

  
  variantImages.forEach(img => {

    const titleElement = img.previousElementSibling;
   const showTitle = () => {
      titleElement.style.display = 'block';
     };
     const hideTitle = () => {
      titleElement.style.display = 'none';
     };
    
    img.addEventListener('mouseover', function() {
      console.log('Mouse over event triggered');
      const imageParent = img.closest('.grid__item') || document;
      console.log("imageParent>>>", imageParent);
      const featuredImg = imageParent.querySelectorAll('.featured_img');
      const newSrc = img.getAttribute('src');
      // const newSrcset = img.getAttribute('data-srcset');
      featuredImg.forEach(item => {
        item.setAttribute('src', newSrc);
        item.removeAttribute('srcset');
      });
      showTitle();
     });

    img.addEventListener('mouseout', function() {
       hideTitle();
      featuredImg.forEach(item => {
        item.setAttribute('src', originalSrc);
        item.setAttribute('srcset', originalSrcset);
      });

    });

    img.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Click event triggered');
      const imageParent = img.closest('.grid__item') || document;
      console.log("imageParent>>>", imageParent);
      const featuredImg = imageParent.querySelectorAll('.featured_img');
      const newSrc = img.getAttribute('src');
      // const newSrcset = img.getAttribute('data-srcset');
      featuredImg.forEach(item => {
        item.setAttribute('src', newSrc);
        item.removeAttribute('srcset');
      });

      // Update originalSrc to the new source after the click
      originalSrc = newSrc;
      // originalSrcset = newSrcset;
showTitle();
     
    });
     titleElement.addEventListener('mouseover', showTitle);
    titleElement.addEventListener('click', showTitle);
    titleElement.addEventListener('mouseout', hideTitle);
  });
             },5000)
  

});


document.addEventListener('DOMContentLoaded', function () {

 const headerSearch = document.querySelector('.header__search');
  const details = headerSearch.querySelector('details');

  headerSearch.addEventListener('click', function () {
    if (details.hasAttribute('open')) {
      headerSearch.classList.add('custom-class');
    }
  });

  details.addEventListener('toggle', function () {
    if (!details.open) {
      headerSearch.classList.remove('custom-class');
    }
  });
});




// Scroll top js start
var amountScrolled = 200;
var amountScrolledNav = 25;

$(window).scroll(function() {
  if ( $(window).scrollTop() > amountScrolled ) {
    $('button.back-to-top').addClass('show');
  } else {
    $('button.back-to-top').removeClass('show');
  }
});

$('button.back-to-top').click(function() {
  $('html, body').animate({
    scrollTop: 0
  }, 400);
  return false;
});
// Scroll top js end
// Cart Drawer js START
  document.querySelector('.select-dropdown').addEventListener('click', function(event) {
    this.classList.toggle('active');
    event.stopPropagation();
  });
  document.querySelector('.dropdown-list').addEventListener('click', function(event) {
    event.stopPropagation();
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('.select-dropdown')) {
      document.querySelector('.select-dropdown').classList.remove('active');
    }
  });

// Cart Drawer js End

// Header On scroll JS Start 
    $(window).scroll(function() {     
    var scroll = $(window).scrollTop();
    if (scroll > 0) {
        $(".header").addClass("active");
    }
    else {
        $(".header").removeClass("active");
    }
});

// Header On scroll JS End
// Checkbox Draer Design START
  // $( document ).ready(function() {
  // $('#toggleTextarea').change(function() {
  //           if ($(this).is(':checked')) {
  //             $('#textarea').css('display', 'block');
  //           } else {
  //             $('#textarea').css('display', 'none');
  //           }
  //         });
  //    });
// End Checkbox Draer Design


